import { gql } from '@apollo/client';
import { BlazeError } from '@blaze-cms/core-errors';
import upperFirst from 'lodash.upperfirst';
import getDataProperties from '../../../../helpers/mappers/get-data-properties';

function buildCreateEntityMutation(entitySchema) {
  if (
    !entitySchema ||
    !entitySchema.actions ||
    !entitySchema.actions.create ||
    !entitySchema.properties
  ) {
    throw new BlazeError(
      'Create entity query requires create action and properties from entity schema'
    );
  }

  const actionInput = upperFirst(`${entitySchema.actions.create}Input`);
  const dataProperties = getDataProperties(entitySchema);

  return gql`mutation createEntity($input:  ${actionInput}) {
    createdEntity: ${entitySchema.actions.create}(input: $input){
        result {
          id,
          ${dataProperties.join(',\n')}
      }
    }
  }`;
}

export default buildCreateEntityMutation;
